<!-- On vérifie que le rootForm existe avant de créer les champs liés -->
<div *ngIf="rootForm && lieuxHosto && ! (modeRenduService.enModeImpression$ | async)">
  <div class="form-row mx-2 pb-3" *ngIf="rootForm && lieuxHosto">
    <div class="col" [formGroup]="rootForm">
      <div>
      <mat-accordion class=" col-12">
        <div *ngFor="let item of lieuxHosto.controls; let i = index">
          <mat-expansion-panel (opened)="setStep(i)">
            <mat-expansion-panel-header>
              <mat-panel-description>
                <mat-icon>account_circle</mat-icon>&#xA0;
                <span [ngClass]="{'onglet-invalide': lieuxHosto.controls[i].invalid}">
                  Informations sur l'hôpital {{ i + 1 }}
                </span>
                <button *ngIf="(modeRenduService.enModeSaisie$ | async)" (click)="supprimerLieuxHosto(i)" class="btn-danger btn-sm ml-auto"
                  title="Supprimer l'hôpital">
                  <i class="material-icons md-18">delete</i>
                </button>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="form-row">
                <div class="col-md-8">
                   <!--<bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxHosto.controls[i]" 
                      nbChoixVisiblePossible="5" label="aaLieuHostoCodCom" nomNomenclature="commune">
                   </bis-filtered-select-input-keypad>-->
                   <bis-commune-input-keypad [rootForm]="lieuxHosto.controls[i]" [preId]="i" nbChoixVisiblePossible=10
                      label="aaLieuHostoCodCom" nomNomenclature="commune">
                   </bis-commune-input-keypad>
                 </div>
                 <div class="col-md-4">
                   <bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxHosto.controls[i]" 
                   infoBulle="Préciser dans le menu déroulant si le lieu de permanence est en quartier prioritaire" label="aaLieuHostoQp" nomNomenclature="ouiNonNsp">
                   </bis-filtered-select-input-keypad>
                 </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                   <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxHosto.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                    label="aaLieuHostoNbPerm" [max]="999" infoBulle="1 demi-journée = 3h" [erreursCroisees]="['ctrlA72Hosto']">
                   </bis-integer-inline-input-keypad>
                   <bis-affiche-erreurs-croisees [rootForm]="lieuxHosto.controls[i]" colorErreur="danger"
                     labelErreur="ctrlA72Hosto">
                  </bis-affiche-erreurs-croisees>
                 </div>
            </div>
            <div class="form-row">
                 <div class="col-md-1"></div>
                 <div class="col-md-10">
                    <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxHosto.controls[i]" classeColLabel="col-8" 
                      classeColInput="col-2" classeSupplInput="text-right" label="aaLieuHostoNbPermEtp" [max]="9999" [erreursCroisees]="['ctrlA73Hosto']"
                      infoBulle="3 personnes présentes sur une demi-journée = 3 demi-journées travaillées">
                    </bis-integer-inline-input-keypad>
                    <bis-affiche-erreurs-croisees [rootForm]="lieuxHosto.controls[i]" colorErreur="danger"
                      labelErreur="ctrlA73Hosto">
                    </bis-affiche-erreurs-croisees>
                    <bis-affiche-alertes [labelAlerte]="'alertA51Hosto_' + i"></bis-affiche-alertes>
                 </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                   <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxHosto.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                   label="aaLieuHostoNbVict" [max]="99999" infoBulle="(physiques et morales)">
                   </bis-integer-inline-input-keypad>
                </div>
           </div>
        </mat-expansion-panel>
        </div>
        </mat-accordion>

        <button *ngIf="modeRenduService.enModeSaisie$ | async" class="mt-4 ml-n1 btn btn-info"
        (click)="ajouterLieuxHosto()">Ajouter un Hôpital</button>

        <div class="form-row mt-4">
            <div class="col-md-6">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuHostoNb" [max]="99" enLectureSeule="true"
                classeColLabel="col-6" classeColInput="col-4"      
                infoBulle="Cette zone est calculée automatiquement à partir du nombre d'hôpital ajouté(s)">
              </bis-integer-inline-input>
          </div>
          <div class="col-md-6">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuHostoNbPermTot" [max]="9999" enLectureSeule="true"
                classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-10">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuHostoNbPermEtpTot" [max]="99999" 
                enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-10">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuHostoNbVictTot" [max]="999999" 
                  enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>  
      </div>
    </div>
  </div>
</div>


<div *ngIf="rootForm && lieuxHosto && (modeRenduService.enModeImpression$ | async)">
  <div class="form-row mx-2 pb-3" *ngIf="rootForm && lieuxHosto">
    <div class="col" [formGroup]="rootForm">
      <div>
        <div *ngFor="let item of lieuxHosto.controls; let i = index">
            <div class="form-row">
                <div class="col-md-8">
                   <!--<bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxHosto.controls[i]" 
                      nbChoixVisiblePossible="5" label="aaLieuHostoCodCom" nomNomenclature="commune">
                   </bis-filtered-select-input-keypad>-->
                   <bis-commune-input-keypad [rootForm]="lieuxHosto.controls[i]" [preId]="i" nbChoixVisiblePossible=10
                      label="aaLieuHostoCodCom" nomNomenclature="commune">
                   </bis-commune-input-keypad>
                 </div>
                 <div class="col-md-4">
                   <bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxHosto.controls[i]" 
                   infoBulle="Préciser dans le menu déroulant si le lieu de permanence est en quartier prioritaire" label="aaLieuHostoQp" nomNomenclature="ouiNonNsp">
                   </bis-filtered-select-input-keypad>
                 </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                   <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxHosto.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                    label="aaLieuHostoNbPerm" [max]="999" infoBulle="1 demi-journée = 3h" [erreursCroisees]="['ctrlA72Hosto']">
                   </bis-integer-inline-input-keypad>
                   <bis-affiche-erreurs-croisees [rootForm]="lieuxHosto.controls[i]" colorErreur="danger"
                     labelErreur="ctrlA72Hosto">
                  </bis-affiche-erreurs-croisees>
                 </div>
            </div>
            <div class="form-row">
                 <div class="col-md-1"></div>
                 <div class="col-md-10">
                    <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxHosto.controls[i]" classeColLabel="col-8" 
                      classeColInput="col-2" classeSupplInput="text-right" label="aaLieuHostoNbPermEtp" [max]="9999" [erreursCroisees]="['ctrlA73Hosto']"
                      infoBulle="3 personnes présentes sur une demi-journée = 3 demi-journées travaillées">
                    </bis-integer-inline-input-keypad>
                    <bis-affiche-erreurs-croisees [rootForm]="lieuxHosto.controls[i]" colorErreur="danger"
                      labelErreur="ctrlA73Hosto">
                    </bis-affiche-erreurs-croisees>
                    <bis-affiche-alertes [labelAlerte]="'alertA51Hosto_' + i"></bis-affiche-alertes>
                 </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                   <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxHosto.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                   label="aaLieuHostoNbVict" [max]="99999" infoBulle="(physiques et morales)">
                   </bis-integer-inline-input-keypad>
                </div>
           </div>
        </div>
        <div class="form-row mt-4">
            <div class="col-md-6">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuHostoNb" [max]="99" enLectureSeule="true"
                classeColLabel="col-6" classeColInput="col-4"      
                infoBulle="Cette zone est calculée automatiquement à partir du nombre d'hôpital ajouté(s)">
              </bis-integer-inline-input>
          </div>
          <div class="col-md-6">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuHostoNbPermTot" [max]="9999" enLectureSeule="true"
                classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-10">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuHostoNbPermEtpTot" [max]="99999" 
                enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-10">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuHostoNbVictTot" [max]="999999" 
                  enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>  
      </div>
    </div>
  </div>
</div>
